import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";
import ProgramTable from '../container/Program/ProgramTable'
// import NewGif from "../components/Gif/NewGif";

// import EmptyOne from '../container/Empty/EmptyOne';

const Program = () => {
  return (
    <React.Fragment>
      <SEO title="Program | ICSI 2022" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Program"
        content="The Conference"
        contentTwo="Program"
        linkage="/"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <h3>Program Schedule</h3>
        
        <div className="space-60"></div>
        {/* <img src="./images/program/program_schedule.jpg" width="90%"></img> */}
        <ProgramTable/>

        {/* <div className="entry-content">
						<h4>Preliminary Schedules for ICSI &apos; 2021</h4>
						<p>July 17th 13:00pm-18:00pm(GMT+8): Onsite Registration</p>
						<p>July 17th 18:00pm-19:30pm(GMT+8): Beer Festival (Reception)</p>
					    <p>July 18th 8:30am-12:00am(GMT+8): Opening Ceremony, Plenary Speeches &amp; Invited Talks</p>
					    <p>July 18th, 13:00pm-17:20pm(GMT+8): Parallel Sessions</p>
					    <p>July 18th, 18:00pm-20:00pm(GMT+8): Award Ceremony &amp; Banquet</p>
					    <p>July 19th, 9:00am-12:00am(GMT+8): Parallel Sessions</p>
					    <p>July 18th, 10:20am-10:40am, 15:00pm-15:20pm(GMT+8): Coffee Breaks</p>
					    <p>July 19th, 10:20am-10:40am(GMT+8): Coffee Breaks</p>
					    <p>July 20th &amp; 21st: Post-event Activities &amp; Tour (free activities, self-pay, not officially organized)</p>
                        <br/>
					    <h4>
					        Zoom for all sessions:
					    </h4>

					    <p>
					        Yan Xi Tang 燕喜堂: 847 7347 7938<br/>
					        Bo Hai Hall 渤海厅：847 7347 7938<br/>
					        Nan Hai Hall 南海厅：826 7855 8364<br/>
					        Huang Hai Hall 黄海厅：812 4427 4048<br/>
					        Zoom I: 826 0784 1667<br/>
					        Zoom II: 859 6443 6186
					    </p>
                        <br/>
					     <img src="http://39.98.207.139:8080/icsi2021/wp-content/uploads/new.gif" alt=""
                                    width={28} height={11}/>
                        
					      <a href="/sessions"><b className="timetable">Detailed Scheduled Presentations Timetables!</b></a>
					</div> */}
          <div className="space-40"></div>
          <div className="newfig">

          <h4>Detailed Scheduled Presentations Timetables</h4>
          </div>
          

        <div className="entry-content2">
          <Link
            className="btn btn-primary btn-hover-secondary  mt-s"
            to={process.env.PUBLIC_URL + "/sessions"}
          >
            Sessions
          </Link>


        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Program;
